import "./Navigation.css";
import { useTranslation } from "react-i18next";
import { HashLink } from "react-router-hash-link";

export default function Navigation() {
  const { t, i18n } = useTranslation();
  return (
    <div className="App">
      <div>
        <div class="navigation">
          <a href="#">
            <img
              src="/img/user4.png"
              style={{
                width: "20px",
                height: "20px",
                // color: "#757575",
                marginLeft: "13px",
                cursor: "pointer",
              }}
            />
          </a>
          <div class="navigation-content">
            <HashLink smooth to="/dashboard">
              {t("Dashboard")}
            </HashLink>
            <HashLink smooth to="/dashboard-personal">
              {t("My Information")}
            </HashLink>
            <HashLink smooth to="/dashboard-address">
              {t("My Address")}
            </HashLink>
            <HashLink smooth to="/dashboard-password">
              {t("Change Password")}
            </HashLink>
            <HashLink smooth to="/dashboard-review">
              {t("Review")}
            </HashLink>
            <HashLink smooth to="/dashboard-support">
              {t("Request a support")}
            </HashLink>
            <HashLink smooth to="/logout">
              {t("Logout")}
            </HashLink>
          </div>
        </div>
        {/* <div class="navigation">
          <a href="#">Menu 2</a>
          <div class="navigation-content">
            <a href="#">Link 1</a>
            <a href="#">Link 2</a>
            <a href="#">Link 3</a>
          </div>
        </div>
        <div class="navigation">
          <a href="#">Single Menu</a>
        </div> */}
      </div>
    </div>
  );
}
